import { withNestedView } from '@/router/routerHelpers';
import { PERMISSIONS } from '@/access/permissions';
import PermissionGate from '@/components/basic/permission-gate/PermissionGate.vue';
const loadView = withNestedView('conversations');

const conversationsRoutes = [
  {
    path: '/conversations',
    component: PermissionGate,
    props: {
      permission: PERMISSIONS.CONTACTS,
      title: 'Conversations',
      placeholderTitle: 'Contact Access Required',
      placeholderText:
        'Your assigned role does not include access to contacts.',
    },
    children: [
      {
        path: 'chat/:typeId/:threadId?',
        name: 'conversations-chat',
        meta: { showNav: true },
        props: true,
        component: loadView('chat/ConversationChatPage'),
      },
      {
        path: ':typeId?/:threadId?/:contactName?',
        name: 'conversations',
        meta: { showNav: true },
        props: true,
        component: loadView('Conversations'),
      },
    ],
  },
];

export default conversationsRoutes;
